import { render, staticRenderFns } from "./FeatureCarousel.vue?vue&type=template&id=681dbb66&scoped=true"
import script from "./FeatureCarousel.vue?vue&type=script&lang=js"
export * from "./FeatureCarousel.vue?vue&type=script&lang=js"
import style0 from "./FeatureCarousel.vue?vue&type=style&index=0&id=681dbb66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681dbb66",
  null
  
)

export default component.exports